export const ENTITY_GROUPS_INITAL_STATE = {
  list: [],
  selected: {
    name: '',
  },
};

export const MAX_TABLE_HEIGHT = '90%'